import React, { type ReactNode } from 'react';
// TODO: JFP-2824 | Suppressed to enable upgrade to ESLint v9 - please fix this if you can!
// eslint-disable-next-line jira/restricted/@atlaskit+analytics-next
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { useQueryParams } from '@atlassian/jira-software-router-utils/src/services/query-params/index.tsx';
import type { Status } from '@atlassian/jira-version-modals/src/common/model/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { QUERY_PARAM_STATUS, QUERY_PARAM_SEARCH } from '../../common/constants.tsx';
import { transformStatusFromParam } from '../../common/utils.tsx';

const useAnalyticsCustomAttributes = () => {
	const projectContext = useResource(projectContextResource);
	const projectId = projectContext?.data?.projectId || undefined;
	const projectType = projectContext?.data?.projectType || undefined;
	const simplified = projectContext?.data?.simplified || undefined;

	const statusAttributes = useFilterAnalytics();

	return {
		projectId,
		projectType,
		simplified,
		...statusAttributes,
	};
};

const hasStatusSelected = (status: Status, statuses: Status[]): boolean =>
	statuses.length === 0 || statuses.some((selectedStatus) => selectedStatus === status);

const useFilterAnalytics = () => {
	const [queryParams] = useQueryParams(QUERY_PARAM_STATUS);
	const statuses = transformStatusFromParam(queryParams[QUERY_PARAM_STATUS]);
	const searchFilter = queryParams[QUERY_PARAM_SEARCH] ?? '';

	return {
		hasReleasedStatusFilter: hasStatusSelected('RELEASED', statuses),
		hasUnreleasedStatusFilter: hasStatusSelected('UNRELEASED', statuses),
		hasArchivedStatusFilter: hasStatusSelected('ARCHIVED', statuses),
		hasSearchFilter: searchFilter.length > 0,
	};
};

type Props = {
	children: ReactNode;
};

export const ProjectVersionsAnalyticsContextProvider = ({ children }: Props) => {
	const attributes = useAnalyticsCustomAttributes();
	return <AnalyticsContext data={{ attributes }}>{children}</AnalyticsContext>;
};
